import "./index.scss";
import { useState } from "react";
import { useGetNotification } from "./utils/useGetNotification";
import { withApolloProvider } from "providers/ApolloClientProvider";
import { GRAPHQL_CMS_BASE_URL } from "constants/endpoints";
import { getSiteBannerCookie, setSiteBannerCookie } from "services/cookies";

const NotificationBanner = () => {
  const [isOpen, setOpen] = useState(true);

  const isVisible = !getSiteBannerCookie();

  const { loading, data, error } = useGetNotification(isVisible);

  const handleCloseClick = () => {
    setSiteBannerCookie();
    setOpen(false);
  };

  const isReady = !loading && !error && isVisible && isOpen && !!data;

  return isReady ? (
    <div
      className="notification-banner"
      style={{
        backgroundColor: data.backgroundColor
      }}
    >
      <div className="click-area">
        <a
          href={data.linkTo}
          style={{
            color: data.textColor
          }}
        >
          <p className="title">{data.title}</p>
          <p className="subtitle">{data.subtitle}</p>
        </a>
      </div>
      <div className="close-area">
        <div className="icon-click" onClick={handleCloseClick}>
          &#10006;
        </div>
      </div>
    </div>
  ) : (
    <div />
  );
};

export default withApolloProvider(NotificationBanner, {
  graphqlEndpoint: GRAPHQL_CMS_BASE_URL
});
